<template>
    <div class="dark-bg pt-5">
        <v-card width="600" class="mx-auto mb-5">
            <img src="@/assets/live-social-feed.png" width="100%" alt="">
            <v-card-title>Account Registration</v-card-title>
            <v-divider></v-divider>
            <v-list dense>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Name" hide-details type="text" outlined dense v-model="user.name"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Contact Number" hide-details type="text" outlined dense v-model="user.contact_number"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Company" hide-details type="text" outlined dense v-model="user.company"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Email" hide-details type="email" outlined dense v-model="user.email"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Password" hide-details type="password" outlined dense v-model="user.password"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Re-enter Password" hide-details type="password" outlined dense v-model="user.password_confirmation"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-text>
                <v-btn color="primary" block @click="submit()">
                    Complete Registration
                </v-btn>
                <div class="text-center mt-2">
                    <v-btn :to="{name : 'Login'}" small text>Login your account</v-btn>
                </div>
            </v-card-text>
        </v-card>

        <v-dialog width="300" v-model="error_dialog" >
            <v-card color="red" class="darken-2" dark>
                <v-list dense color="red">
                    <v-list-item v-for="e in errors" :key="e">
                        <v-list-item-content>
                            {{ e }}
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text small @click="error_dialog = false;">close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog width="300" v-model="success_dialog" >
            <v-card color="success" class="darken-2" dark>
                <v-card-title>Success!</v-card-title>
                <v-card-text>
                    Registration has been submitted.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text small :to="{name : 'Login'}">Login Now</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name : 'RegistrationView',
    data() {
        return {
            user : {},
            errors : [],
            error_dialog : false,
            success_dialog : false
        }
    },
    mounted() {
        console.log(this.user);
    },
    methods : {
        submit() {
            axios({
                url : this.$store.state.api_url + '/register',
                method : 'POST',
                data : this.user
            }).then(res => {
                this.success_dialog = true;
            }).catch(err => {
                this.errors = err.response.data.errors;
                this.error_dialog = true;
            })
        }
    }
}
</script>
<style scoped>
.dark-bg {
    background : #1a191f;
    width: 100%;
    height : 100%;
}
</style>